import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: {},
  detailData: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  EXPENSES_SUMMARY_REQUEST: (selectedYears, company, year, month, dimDate) => ({
    selectedYears,
    company,
    year,
    month,
    dimDate,
  }),
  EXPENSES_DETAIL_REQUEST: (selectedYears, company, year, month, dimDate) => ({
    selectedYears,
    company,
    year,
    month,
    dimDate,
  }),
  EXPENSES_SUCCESS: (payload) => payload,
  EXPENSES_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const detailReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    EXPENSES_SUMMARY_REQUEST: summaryReducer,
    EXPENSES_DETAIL_REQUEST: detailReducer,
    EXPENSES_SUCCESS: successReducer,
    EXPENSES_FAILURE: failureReducer,
  },
  initState,
);
